import { useToggle } from '@startlibs/core';
import { getFetcher, wrapLazy } from '@startlibs/utils';
import _ from 'lodash/fp';
import React, { createContext, useEffect, useState } from 'react';
import { createAutoRefreshableJwtFromLazy } from '../uploader/lib/utils/autoRefershableJwtFromLazy';

export const DicomRouterContext = createContext();


const lazyJwt = wrapLazy((currentJwt) =>
  // getFetcher("/dicomrouterauth.php").then(_.get('jwt')).catch(formatUnauthorizedError)
  getFetcher("/dicomrouterauth.php").then(response => response.trim()).catch((e) => {console.log(e); return currentJwt})
)

const getDicomRouterJwt = createAutoRefreshableJwtFromLazy(lazyJwt, 4)

export const DicomRouterProvider = ({ children }) => {

    // const [funeralInfo, setFuneralInfo] = useState({});
    const [isSelectingStudiesToRoute, setIsSelectingStudiesToRoute] = useState(false)
    const [selectedStudiesToRoute, setSelectedStudiesToRoute] = useState([])
    const [routingDicomsList, setRoutingDicomsList] = useState([])
    const [numberOfSelectedStudies, setNumberOfSelectedStudies] = useState(0) // this ensures updates acrros table and panels
    const dicomsRoutingPanelToggle = useToggle()

    useEffect(() => {
        // lazyJwt.use().promise().catch()
        lazyJwt.use().promise()
        .then((res) => {
            if(res){
                getDicomRouterJwt()
            }
        })
        .catch((e) => {
            console.log(e)
        })
    }, [])
    
    return (
        <DicomRouterContext.Provider value={{ 
            isSelectingStudiesToRoute, setIsSelectingStudiesToRoute,
            selectedStudiesToRoute, setSelectedStudiesToRoute,
            routingDicomsList, setRoutingDicomsList,
            setNumberOfSelectedStudies,
            dicomsRoutingPanelToggle,
            getDicomRouterJwt
            }}>
        {children}
        </DicomRouterContext.Provider>
    );
};